/**
 * Busca en roleDetalles (contexto: controller.roleDetalles = data.roles del login)
 * la fila cuyo módulo coincide con el texto enviado y devuelve si existe y sus valores.
 *
 *   const { encontrado, registro, valores } = getPermisosPorModulo(controller.roleDetalles, "Pagos");
 *   const same = usePermisosModulo("Pagos");
 */

import { useMaterialUIController } from "context";

/** Claves donde puede venir el nombre del módulo en cada fila (rolesusuarios). */
const CLAVES_MODULO = ["modulo", "Modulo", "nombre", "Nombre", "descripcion", "Descripcion", "clave", "Clave"];

/** Campos de metadato que no son permisos sueltos. */

function normalizar(txt) {
  if (txt === undefined || txt === null) return "";
  return String(txt).trim().toLowerCase();
}


/**
 * @param {Array<object>} roleDetalles
 * @param {string} modulo - nombre del módulo (ej. "Pagos")
 * @returns {{
 *   encontrado: boolean,
 *   registro: object | null,
 *   valores: Record<string, unknown>,
 * }}
 */
export function getPermisosPorModulo(roleDetalles, modulo) {
  const lista = Array.isArray(roleDetalles) ? roleDetalles : [];
  
  const pedido = normalizar(modulo);
  
  if (!pedido) {
    return { encontrado: false, registro: null, valores: {} };
  }

  const registro = lista.find((row) => normalizar(row.programa) === pedido) ?? null;
  
  if (!registro) {
    return { encontrado: false, registro: null, valores: {} };
  }

  const valores = {}
  return { encontrado: true, registro, valores };
}

export function getPermisosPorModuloAccion(roleDetalles, modulo) {
  const lista = Array.isArray(roleDetalles) ? roleDetalles : [];
  
  const pedido = normalizar(modulo);
  
  if (!pedido) {
    return { encontrado: false, registro: null, valores: {} };
  }

  const registro = lista.find((row) => normalizar(row.categoria) === pedido) ?? null;
  
  if (!registro) {
    return { encontrado: false, registro: null, valores: {} };
  }

  const valores = {}
  return { encontrado: true, registro, valores };
}

/** Indica si existe una fila en roles para el módulo indicado (alias simple de getPermisosPorModulo). */
export function tienePermisosModulo(roleDetalles, modulo) {
  return getPermisosPorModulo(roleDetalles, modulo).encontrado;
}

/** Convierte el valor recibido del backend ('S'/'s'/1/true) a booleano. */
function esPermisoActivo(valor) {
  if (valor === true || valor === 1) return true;
  if (valor === null || valor === undefined) return false;
  const v = String(valor).trim().toLowerCase();
  return v === "s" || v === "si" || v === "1" || v === "true";
}

/**
 * Verifica si la fila del módulo tiene la columna `accion` activa.
 * Ej.: puedeAccion(controller.roleDetalles, "pagos", "borrar")
 */
export function puedeAccion(roleDetalles, modulo, accion) {
  const { registro } = getPermisosPorModuloAccion(roleDetalles, modulo);
  
  if (!registro) return false;
  return esPermisoActivo(registro[accion]);
}

/**
 * Indica si un permiso concreto está activo (acepta S/s/1/true/"si").
 *
 * @param {unknown} valor
 */
export function usePermisosModulo(modulo) {
  const [controller] = useMaterialUIController();
  return getPermisosPorModulo(controller.roleDetalles, modulo);
}
